<template>
  <div class="flex overflow-hidden flex-col h-full bg-light-linen">
    <div class="relative">
      <img
        alt="Beautiful pasta dish"
        class="object-cover w-full h-auto max-h-64"
        loading="lazy"
        src="https://cdn.shopify.com/s/files/1/1725/5449/files/ab6edda266dc1603de3c3ffa98ff13a5_1_1.webp?v=1714649033"
      />
    </div>
    <div class="px-8 py-6 bg-light-linen">
      <h2 class="mb-6 text-3xl font-light text-terracota font-brand">Beautiful pasta awaits...</h2>
      <ul class="space-y-4 text-off-black">
        <li class="flex items-center">
          <div class="flex justify-center items-center mr-4 rounded-full size-10 bg-linen shrink-0">
            <HowItWorksIcon icon="check" class="size-8 text-terracota-muted" />
          </div>
          <span class="text-base text-off-black">Order a one-off recipe kit or subscribe.</span>
        </li>
        <li class="flex items-center">
          <div class="flex justify-center items-center mr-4 rounded-full size-10 bg-linen shrink-0">
            <HowItWorksIcon icon="calendar" class="size-6 text-terracota-muted" />
          </div>
          <span class="text-base text-off-black">
            Subscribers can skip, pause or cancel anytime, and can hand pick dishes each week.
          </span>
        </li>
        <li class="flex items-center">
          <div class="flex justify-center items-center mr-4 rounded-full size-10 bg-linen shrink-0">
            <HowItWorksIcon icon="snowflake" class="size-8 text-terracota-muted" />
          </div>
          <span class="text-base text-off-black">Freeze dishes for up to 1 month.</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
  defineEmits<{ (e: 'close'): void }>();
</script>
